<div class="annual-outcome-wrapper">
  <div class="details dis-flex flex-sb">
    <div class="tags m-b-15">
      <div class="dis-flex">
        <p-chip class="theme">
          <span
            class="theme-color theme-green"
            [style.background-color]="outcomesData?.theme?.color"
          ></span>
          <span class="title b3 text-80 lh-2-0">
            {{ outcomesData?.theme?.value }}
          </span>
        </p-chip>
        <p-divider class="vertical-divider" layout="vertical" />
        <p-chip
          class="b3 radius-8 status-chip"
          [ngClass]="{
            'not-started': outcomesData.status === 1,
            ongoing: outcomesData.status === 2,
            completed: outcomesData.status === 3,
            delayed: outcomesData.status === 4,
            terminated: outcomesData.status === 5
          }"
          [label]="getLabel(outcomesData?.status)"
        />
      </div>
    </div>
  </div>
  <div class="content-title">
    <h3 class="font-medium">
      {{ outcomesData?.value }}
    </h3>
    <div *ngIf="!isAffiliate">
      <div class="b3 font-medium text-80" ngbTooltip="Short Term Outcomes">STO Status</div>
      <div class="milestone-status m-b-5">
        <p-chip
          class="b3 font-medium radius-8 milestone-count-chip not-started m-r-10"
          label="Not Started: {{
            getMilestoneCount(outcomesData?.quarterly, 1)
          }}"
        />
        <p-chip
          class="b3 font-medium radius-8 milestone-count-chip ongoing m-r-10"
          label="Ongoing: {{ getMilestoneCount(outcomesData?.quarterly, 2) }}"
        />
        <p-chip
          class="b3 font-medium radius-8 milestone-count-chip completed m-r-10"
          label="Completed: {{ getMilestoneCount(outcomesData?.quarterly, 3) }}"
        />
        <p-chip
          class="b3 font-medium radius-8 milestone-count-chip delayed m-r-10"
          label="Delayed: {{ getMilestoneCount(outcomesData?.quarterly, 4) }}"
        />
        <p-chip
          class="b3 font-medium radius-8 milestone-count-chip terminated m-r-10"
          label="Terminated: {{
            getMilestoneCount(outcomesData?.quarterly, 5)
          }}"
        />
      </div>
    </div>
  </div>
</div>
